export default __webpack_public_path__ + "static/media/team (1).a138ca26.png";